import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowLeftSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM6.68945 12L11 16.3105L12.0605 15.25L9.56055 12.75H17V11.25H9.56055L12.0605 8.75L11 7.68945L6.68945 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftSquare;
